import { DraggableGroup, DraggableGroupItem } from '@common-fe/common-fe';

import { DIVIDING_MODE_MAIN_GROUP_KEY } from '@/modules/employer/components/Lockbox/lockbox.types';
import { storeCreator } from '@/utils/store/store.utils';

const DEFAULT_VALUE: DraggableGroup[] = [
  {
    key: DIVIDING_MODE_MAIN_GROUP_KEY,
    title: 'Main Record',
    items: [],
  }
];

interface State {
  groups: DraggableGroup[];
  activeGroupKey?: string;
  updatedItemsSet: Set<string>;
  numberOfPages: number;
  setGroups: (groups: DraggableGroup[]) => void;
  setActiveGroupKey: (key?: string) => void;
  updateItemById: (groupKey: string, itemKey: string, updatedItem: Partial<DraggableGroupItem>) => void;
  setNumberOfPages: (numberOfPages: number) => void;
  reset: () => void
}

export const useLockboxDividingModeStore = storeCreator<State>((set) => ({
  groups: DEFAULT_VALUE,
  activeGroupKey: DIVIDING_MODE_MAIN_GROUP_KEY,
  updatedItemsSet: new Set<string>(),
  numberOfPages: 0,

  setGroups: (groups: DraggableGroup[]) => set(() => ({
    groups,
  })),

  setActiveGroupKey: (activeGroupKey?: string) => set(() => ({
    activeGroupKey,
  })),
  
  updateItemById: (groupKey: string, itemKey: string, updatedItem: Partial<DraggableGroupItem>) =>
    set((state) => {
      const newUpdatedSet = new Set(state.updatedItemsSet);
      newUpdatedSet.add(itemKey);

      return {
        groups: state.groups.map((group) =>
          group.key === groupKey
            ? {
              ...group,
              items: group.items?.map((item) =>
                item.key === itemKey ? { ...item, ...updatedItem } : item
              ),
            }
            : group
        ),
        updatedItemsSet: newUpdatedSet,
      };
    }),

  setNumberOfPages: (numberOfPages: number) => set(() => ({
    numberOfPages: numberOfPages,
  })),
    
  reset: () => set(() => ({
    groups: DEFAULT_VALUE,
    activeGroupKey: DIVIDING_MODE_MAIN_GROUP_KEY,
    updatedItemsSet: new Set(),
    numberOfPages: 0,
  })),
}));
